import { createSvgIcon } from '@mui/material/utils';

const ObraPlay = createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.52539 7.89469C6.1558 7.89401 9.78624 7.89334 13.4167 7.89266C13.276 5.64189 12.3637 3.83556 10.2724 2.70851C10.3511 3.15302 10.4298 3.59755 10.5085 4.04207C10.3995 4.05981 10.2905 4.07757 10.1816 4.09531C10.0431 3.30727 9.90474 2.51924 9.76632 1.73118C8.50293 1.20308 7.26728 1.18487 6.06451 1.77205C5.91737 2.54752 5.77023 3.32297 5.62307 4.09844C5.51636 4.07792 5.40968 4.05741 5.30299 4.03689C5.37511 3.61678 5.44722 3.19666 5.51935 2.77656C3.4688 4.02158 2.61842 5.79232 2.52539 7.89469ZM7.08319 3.29104C6.85287 3.14818 6.63147 3.22287 6.63197 3.54905C6.63182 4.55391 6.63164 5.55874 6.63147 6.5636C6.63147 6.85894 6.79379 6.96298 7.08319 6.81925C7.91851 6.3166 8.75385 5.81396 9.58917 5.31131C9.83516 5.16182 9.86404 4.97738 9.58917 4.7994C8.75385 4.2966 7.91851 3.79383 7.08319 3.29104Z"
      fill="black"
      fill-opacity="0.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.10145 9.02756C3.85331 9.02812 4.60515 9.02866 5.35701 9.02922C5.6537 12.1116 10.2329 12.4544 10.6726 9.02922C11.425 9.02866 12.1775 9.02812 12.93 9.02756C12.837 10.0576 12.6542 9.66978 13.7912 10.1273C13.6192 10.5906 13.4472 11.0538 13.2752 11.5171C12.119 11.1389 12.4895 10.9693 11.9865 11.7438C11.489 12.4432 11.3883 12.0779 12.1245 13.0564C11.7338 13.3485 11.3431 13.6406 10.9524 13.9327C10.208 13.0374 10.6117 13.1009 9.60338 13.5162C8.67404 13.8985 8.728 13.3131 8.75339 14.6667C8.26282 14.6667 7.77226 14.6667 7.28168 14.6667C7.29774 13.3752 7.41671 13.8573 6.34525 13.4768C5.37013 13.0808 5.74874 12.9304 5.00847 13.8938C4.62084 13.5914 4.23321 13.289 3.84558 12.9867C4.54827 12.0091 4.60713 12.4852 3.86822 11.5027C3.309 10.657 3.8327 10.6297 2.51612 10.9935C2.39324 10.5183 2.27033 10.0431 2.14746 9.56795C2.88934 9.37749 3.20486 9.39693 3.10145 9.02756ZM4.70426 9.53475C5.16972 11.2441 6.48165 12.1776 8.17546 12.1854C8.17546 12.294 8.17546 12.4025 8.17546 12.5111C6.62005 12.5117 4.87998 11.6137 4.39359 9.62383C4.49714 9.59413 4.60071 9.56445 4.70426 9.53475Z"
      fill="black"
      fill-opacity="0.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 8.66091C5.97489 8.66162 9.94979 8.66233 13.9247 8.66305C13.9113 8.41455 13.8508 8.26435 13.6606 8.25464C9.87442 8.25464 6.0882 8.25464 2.30199 8.25464C2.0919 8.25975 2.01895 8.42739 2 8.66091Z"
      fill="black"
      fill-opacity="0.5"
    />
  </svg>,
  'ObraPlay'
);

export default ObraPlay;
